<template>
  <div
    class="user-center__access-record-container user-center__common-child-container user-supplier-child-container"
  >
    <SubPageHeader>
      <template #title>
        <router-link
          tag="div"
          :to="nav.url"
          active-class="active"
          class="title__front-item"
          v-for="(nav, index) in breadcrumbs"
          :key="index"
        >{{ nav.name }}</router-link>
      </template>
      <template #bt>
        <div class="bt-item" @click="handleAdd">新增供应商</div>
      </template>
    </SubPageHeader>
    <div class="access-record__main-body" v-if="lists && lists.length > 0">
      <div class="access-record__item">
        <div class="item__child">店铺名称</div>
        <div class="item__child">分类</div>
        <div class="item__child">店铺联系人</div>
        <div class="item__child">店铺手机号</div>
        <!-- <div class="item__child">创建时间</div> -->
        <div class="item__child" style="width: 300px;">操作</div>
      </div>
      <div class="access-record__item" v-for="list in lists" :key="list.id">
        <div class="item__child ellipsis1">{{list.company}}</div>
        <div class="item__child ellipsis1">{{list.cat_name}}</div>
        <div class="item__child ellipsis1">{{list.contacts}}</div>
        <div class="item__child">{{list.phone}}</div>
        <!-- <div class="item__child">{{list.ctime | parseTime}}</div> -->
        <div class="item__child" style="width: 300px;">
          <el-button type="primary" size="mini" :loading="loading" @click="onEdit(list)">修改</el-button>
          <el-button  size="mini" @click="del(list.id)">删除</el-button>
          <el-button  size="mini" @click="detail(list)">查看店铺</el-button>
        </div>
      </div>
    </div>
    <empty hint="没有找到相关信息" v-else></empty>
    <pagination class="component-pagination" v-if="paginationConfig" :config="paginationConfig"></pagination>

    <!-- 新增供应商 -->
    <el-dialog
      custom-class="supplier-dialog"
      :title="title"
      :visible.sync="addVisible"
      width="588px"
      :close-on-click-modal="false"
    >
      <div class>
        <el-form
          :model="form"
          class="requirement-reply-form"
          :rules="rules"
          ref="addForm"
          label-width="118px"
        >
          <el-form-item class="company-c" prop="company" label="店铺名称">
            <!-- <el-input v-if="title != '详情'" v-model="form.company" @input="onBlur" placeholder="请输入店铺名称" maxlength="20"></el-input>
            <span style="line-height: 40px;" v-else>{{form.company}}</span>
            <ul v-if="showList">
              <li v-for="(item,index) in supplierList" :key="index" @click="onSelect(item)">
                {{item.name}}
              </li>
            </ul> -->
            <el-select
              style="width: 100%;"
              v-model="form.company"
              filterable
              remote
              reserve-keyword
              placeholder="请输入供应商"
              @change="onSelect"
              :remote-method="onBlur"
              :loading="loading">
              <el-option
                v-for="item in supplierList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>

          </el-form-item>
          <el-form-item class prop="cat_name" label="分类">
            <el-input v-if="title != '详情'" placeholder="请输入分类" v-model="form.cat_name"></el-input>
            <span style="line-height: 40px;" v-else>{{form.cat_name}}</span>
          </el-form-item>
          <el-form-item class prop="contacts" label="店铺联系人">
            <el-input v-if="title != '详情'" placeholder="请输入店铺联系人" v-model="form.contacts"></el-input>
            <span style="line-height: 40px;" v-else>{{form.contacts}}</span>
          </el-form-item>
          <el-form-item class prop="phone" label="店铺手机号">
            <el-input v-if="title != '详情'" placeholder="请输入店铺手机号" v-model="form.phone"></el-input>
            <span style="line-height: 40px;" v-else>{{form.phone}}</span>
          </el-form-item>
          <div class="form__bts-proposal"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" v-if="title != '详情'" :loading="loading" @click="onAdd">保存</el-button>
        <el-button size="mini" @click="addVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Empty from "@/pages/common/empty.vue";
import { scrollToUp } from "@/assets/utils/common";
import { lists, addSupplier, editSupplier, delSupplier } from "@/api/supplier";
import { getSupplierInfo } from "@/api/user";
import Pagination from "@/components/pagination.vue";
import SubPageHeader from "../_pageHeader.vue";
import { userDel } from "@/api/common";
  import {
    mapState
  } from 'vuex';

export default {
  components: {
    SubPageHeader,
    Pagination,
    Empty
  },
  data() {
    return {
      breadcrumbs: [
        {
          name: "我的供应商",
          url: "/my/supplier"
        }
      ],
      pageSize: 16,
      paginationConfig: null,
      lists: null,
      requesting: false,
      addVisible: false,
      loading: false,
      form: {},
      title: "",
      rules: {
        company: [
          {
            required: true,
            message: "请输入店铺名称",
            trigger: "change"
          }
        ],
        cat_name: [
          {
            required: true,
            message: "请输入分类",
            trigger: "change"
          }
        ],
        contacts: [
          {
            required: true,
            message: "请输入店铺联系人",
            trigger: "change"
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入店铺手机号",
            trigger: "change"
          }
        ]
      },
      showList: false,
      supplierList: [],
    };
  },
  computed: mapState({
    userInfo: ({ user: { info } }) => info,
    page() {
      return this.$route.query.page || 1;
    }
  }),
  watch: {
    $route: {
      handler: "init",
      immediate: true
    },
    addVisible(newName, oldName) {
      if (oldName) {
        this.loading = false;
        this.supplierList = [];
        this.showList = false;
        this.$refs.addForm.resetFields();
      }
    }
  },
  methods: {
    async init() {
      // 获取数据
      this.$store.commit("openLoading");
      const res = await lists({
        page: this.page,
        page_size: this.pageSize
      });
      const { data } = res;
      this.lists = data.list;
      this.paginationConfig = data.total;
      scrollToUp();
      this.$store.commit("closeLoading");
    },
    async onBlur(val) {
      console.log(val, 888)
      if(val){
        let res1 = await getSupplierInfo({store_name: val})
        this.supplierList = res1.data.list
        if(this.supplierList.length > 0) this.showList = true
        return this.supplierList
      }
    },
    onAdd(info, type) {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.api = this.title == "新增供应商" ? addSupplier : editSupplier;
          this.api(this.form)
            .then(res => {
              this.loading = false;
              this.addVisible = false;
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.init();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    handleAdd() {
      this.addVisible = true;
      this.title = "新增供应商";
      this.form = {};
    },
    onEdit(list) {
      this.addVisible = true;
      this.title = "修改供应商";
      this.$set(this, "form", JSON.parse(JSON.stringify(list)));
    },
    async detail(list) {
      let res = await getSupplierInfo({store_name: list.company})
      if(res.data.list.length > 0) {
        this.$router.push(`/merchant/${list.store_id}/cases`)
      }else{
        this.$message({
            type: "error",
            message: `该商家尚未入驻本平台`
          });
      }
    },
    del(id) {
      const that = this;
      userDel(
        "确定删除该供应商？",
        () => delSupplier({ id }),
        () => {
          this.init();
        }
      );
    },
    onSelect(id){
      // console.log(id, 123)
      let finder = this.supplierList.find(e => e.id == id) || {}
      this.$set(this.form, 'user_id', this.userInfo.id)
      this.$set(this.form, 'store_id', finder.id)
      this.$set(this.form, 'company', finder.name)
      this.$set(this.form, 'contacts', finder.contact)
      this.$set(this.form, 'cat_name', finder.cat_name)
      this.$set(this.form, 'phone', finder.phone)
    },
  }
};
</script>

<style lang="scss">
.user-supplier-child-container {
  .item__child {
    width: 22%;
    &:first-child {
      width: 34%;
    }
  }
}
.supplier-dialog {
  .el-input__inner {
    height: 38px !important;
    line-height: 38px !important;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .el-button--primary {
    background: #fabe00 !important;
    border-color: #fabe00 !important;
    color: #fff;
  }
  .company-c {
    position: relative;
  }
  ul {
    position: absolute;
    padding: 10px 0;
    border: 1px solid #eee;
    background: #fff;
    border-radius: 8px;
    max-height: 285px;
    overflow-y: auto;
    z-index: 9;
    li {
      line-height: 30px;
      cursor: pointer;
      border-bottom: 1px solid #eee;
      padding: 0 20px;
    }
  }
}
.v-modal {
  z-index: 0 !important;
}
</style>
